import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';
import { Stack, Typography, Box, TextField, Dialog, DialogContent } from '@mui/material';
import axios from '../../utils/axios';
import { objectToFormData } from '../../utils/objectToFormData';
import updateItemInPlaceOrAppend from '../../utils/updateItemInPlaceOrAppend';

ProductCategoryForm.propTypes = {
  editProductCategory: PropTypes.object,
  setProductCategories: PropTypes.func,
  open: PropTypes.bool,
  close: PropTypes.func
}

export default function ProductCategoryForm({ editProductCategory, setProductCategories, open, close }) {
  const { enqueueSnackbar } = useSnackbar();

  const [submitting, setSubmitting] = useState(false);
  const [formValue, setFormValue] = useState({});

  useEffect(() => { setFormValue(editProductCategory ?? {}); }, [open]);

  const onSubmit = () => {
    setSubmitting(true);
    axios.post("/productCategory/productCategoryForm", objectToFormData(formValue))
      .then((res) => {
        if (res.data) {
          enqueueSnackbar(`Product category ${(editProductCategory ? "updated" : "created")}`, { variant: 'success' });
          setProductCategories(productCategories => updateItemInPlaceOrAppend(productCategories, res.data));
          close();
        }
        else enqueueSnackbar(`${(editProductCategory ? "Update" : "Create")} product category failed`, { variant: 'error' })
      })
      .catch(() => enqueueSnackbar(`${(editProductCategory ? "Update" : "Create")} product category failed`, { variant: 'error' }))
      .finally(() => setSubmitting(false));
  };

  return <Dialog open={open} onClose={close} maxWidth="md" >
    <DialogContent>
      <Stack spacing={1} minWidth="600px">
        <Box>
          <Typography variant="subtitle1">Product Category Name*</Typography>
          <TextField
            name="name"
            size="small"
            placeholder="Enter Product Category Name"
            fullWidth
            value={formValue.name}
            onChange={(e) => setFormValue(form => ({ ...form, name: e.target.value }))}
          />
        </Box>      
        <Box>
          <LoadingButton loading={submitting} disabled={!formValue?.name} sx={{ display: "flex", justifySelf: "center", mb: 1, mt: 1, px: 7 }}
            color="purple" size="medium" variant="contained" onClick={onSubmit}>
            Save
          </LoadingButton>
        </Box>
      </Stack>
    </DialogContent>
  </Dialog>;
}